import React from "react";
var __jsx = React.createElement;
import classNames from "classnames";
import AwesomeIcon from "../../AwesomeIcon";
import { faSquare, faSquareCheck } from "@fortawesome/pro-regular-svg-icons";
export var CheckboxWrapper = function CheckboxWrapper(_ref) {
  var id = _ref.id,
    isSelected = _ref.isSelected,
    onToggle = _ref.onToggle,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames("flex rounded-2xl gap-2", isSelected ? "bg-teal-500/[0.12] dark:bg-teal-300/[0.16]" : "bg-gray-200 dark:bg-gray-800")
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onToggle(id);
    },
    className: "pl-2 mt-2 mb-auto cursor-pointer",
    "aria-label": isSelected ? "Deselect" : "Select"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isSelected ? faSquareCheck : faSquare,
    className: classNames("w-[14px] h-[14px]", {
      "dark:text-teal-300": isSelected
    })
  })), children);
};